import React from 'react'
import PropTypes from 'prop-types'
import {Radio} from "antd"

RadioInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired
}

function RadioInput(props) {
    function _onChange(e) {
        const {value} = e.target
        const {onChange} = props

        if (typeof onChange === 'function') {
            onChange(value)
        }
    }

    const {label, value} = props

    return (
        <div className="RadioInput">
            <label htmlFor="">{label} <span className='Required'>*</span></label>
            <Radio.Group value={value} onChange={_onChange}>
                <Radio value={true}>Active</Radio>
                <Radio value={false}>Deactive</Radio>
            </Radio.Group>
        </div>
    )
}

export default RadioInput